import React from 'react';

const HairColorStep = ({ data, updateData, onNext }) => {
  const colors = [
    { id: 'blonde', label: 'Blonde', image: 'https://assets.fnlfx.com/01JCK7J968NQ12EZXRTXVEGDYX/qac7Fz.webp' },
    { id: 'brunette', label: 'Brunette', image: 'https://assets.fnlfx.com/01JCK7J968NQ12EZXRTXVEGDYX/1T36aK.webp' },
    { id: 'black', label: 'Black', image: 'https://assets.fnlfx.com/01JCK7J968NQ12EZXRTXVEGDYX/zz78qX.webp' },
    { id: 'red', label: 'Red', image: 'https://assets.fnlfx.com/01JCK7J968NQ12EZXRTXVEGDYX/-ngmYf.webp' }
  ];

  const handleSelect = (colorId) => {
    updateData('hairColor', colorId);
    setTimeout(() => onNext(), 300);
  };

  return (
    <div className="text-center">
      <h1 className="text-white text-2xl md:text-3xl font-bold mb-4">
        What is your AI girlfriend's hair color?
      </h1>
      <p className="text-white/70 text-sm md:text-base mb-8">
        Select the most exciting option now
      </p>

      <div className="grid grid-cols-2 gap-4">
        {colors.map((color) => (
          <button
            key={color.id}
            onClick={() => handleSelect(color.id)}
            className={`group relative overflow-hidden rounded-2xl transition-all duration-300 hover:scale-105 ${
              data.hairColor === color.id ? 'ring-4 ring-[#F1B428]' : ''
            }`}
          >
            <div className="aspect-[5/7] relative bg-[#1A1A1A]">
              <img
                src={color.image}
                alt={color.label}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <span className="text-white text-lg font-semibold">{color.label}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default HairColorStep;
